import { render, staticRenderFns } from "./RollCallTeacher.vue?vue&type=template&id=22cf7b0c&scoped=true"
import script from "./RollCallTeacher.vue?vue&type=script&lang=js"
export * from "./RollCallTeacher.vue?vue&type=script&lang=js"
import style0 from "./RollCallTeacher.vue?vue&type=style&index=0&id=22cf7b0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cf7b0c",
  null
  
)

export default component.exports